// Browser convenience adapters: authoritative callers pass explicit content to the shared rules.
import * as rules from '../../../../shared/src/rules/items';
import { content, type GameContent } from '../content';
import { ContainerId } from '../../../../shared/src/constants';
export * from '../../../../shared/src/rules/items';

export class Inventory extends rules.Inventory {
  constructor(private readonly explicitContent?: GameContent) { super(explicitContent ?? content()); }
  override get content(): GameContent { return this.explicitContent ?? content(); }
  static override canPlace(c: ContainerId, index: number, s: rules.ItemStack, definitions = content(), weapon?: number): boolean {
    return rules.Inventory.canPlace(c, index, s, definitions, weapon);
  }
}
export const itemDef = (id: number) => rules.itemDef(id, content());
export const isValidItem = (id: number) => rules.isValidItem(id, content());
export const maxStack = (id: number) => rules.maxStack(id, content());
export const toolOf = (id: number) => rules.toolOf(id, content());
export const armorOf = (id: number) => rules.armorOf(id, content());
export const sellPriceOf = (id: number) => rules.sellPriceOf(id, content());
export const bindingOf = (id: number) => rules.bindingOf(id, content());
export const qualityOf = (id: number) => rules.qualityOf(id, content());
export const allItems = () => rules.allItems(content());
